export default __webpack_public_path__ + "static/media/mixed-badges.a11e7249.png";